// list of routes related to user role
import { ReactNode } from 'react'
import { matchPath } from 'react-router-dom'

interface RoutesType {
  [index: string]: Array<{ path: string; component: () => Promise<ReactNode> }>
}

export const routes: RoutesType = {
  super_manager: [
    { path: '/profile', component: () => import('pages/SuperManager/Profile') },
    { path: '/dashboard', component: () => import('pages/SuperManager/Dashboard') },
    {
      path: '/clients-jobs',
      component: () => import('pages/SuperManager/Jobs/ClientsJobs/index')
    },
    {
      path: '/jobs/:jobId/candidates/:candidateId',
      component: () => import('pages/SuperManager/Candidates/View/index')
    },
    { path: '/jobs', component: () => import('pages/SuperManager/Jobs/List') },
    { path: '/clients', component: () => import('pages/SuperManager/Clients/List') },
    {
      path: '/super_manager/managers/:id',
      component: () => import('pages/SuperManager/ProfileView/Manager')
    },
    { path: '/notifications', component: () => import('pages/Notifications/index') },

    /* @deprecated */
    {
      path: '/super_manager/jobs/view/:id',
      component: () => import('pages/SuperManager/Jobs/View/index')
    },
    {
      path: '/super_manager/jobs/:jobId/candidates/:candidateId',
      component: () => import('pages/SuperManager/Candidates/View/index')
    },
    { path: '/super_manager/jobs', component: () => import('pages/SuperManager/Jobs/List') },
    {
      path: '/jobs/view/:id',
      component: () => import('pages/SuperManager/Jobs/View/index')
    }
  ],

  manager: [
    { path: '/profile', component: () => import('pages/Manager/Profile/index') },
    { path: '/dashboard', component: () => import('pages/Manager/Dashboard/index') },
    {
      path: '/manager/job-drafts/:id',
      component: () => import('pages/Manager/JobDrafts/View/index')
    },
    {
      path: '/manager/job-drafts',
      component: () => import('pages/Manager/JobDrafts/List/index')
    },
    { path: '/jobs/view/:id', component: () => import('pages/Manager/Jobs/View/index') },
    {
      path: '/jobs/:jobId/candidates/:candidateId',
      component: () => import('pages/Manager/Candidates/View/index')
    },
    {
      path: '/manager/candidates/:candidateId',
      component: () => import('pages/Manager/Candidates/View/index')
    },
    {
      path: '/jobs/:id/candidates',
      component: () => import('pages/Manager/Candidates/List/index')
    },
    { path: '/jobs/:id', component: () => import('pages/Manager/Jobs/Edit/index') },
    { path: '/jobs/clone/:id', component: () => import('pages/Manager/Jobs/Edit/index') },
    { path: '/jobs', component: () => import('pages/Manager/Jobs/List/index') },
    { path: '/clients', component: () => import('pages/Manager/Clients/List/index') },
    {
      path: '/manager/recruiters/:id',
      component: () => import('pages/Manager/ProfileView/Recruiter')
    },
    { path: '/manager/recruiters', component: () => import('pages/Manager/Recruiters/List/index') },
    {
      path: '/manager/managers/:id',
      component: () => import('pages/Manager/ProfileView/Manager')
    },
    { path: '/calendar', component: () => import('pages/Manager/Calendar/index') },
    {
      path: '/campaigns/view/:id',
      component: () => import('pages/Manager/Campaigns/View/index')
    },
    {
      path: '/campaigns/edit/:id',
      component: () => import('pages/Manager/Campaigns/Edit/index')
    },
    { path: '/campaigns', component: () => import('pages/Manager/Campaigns/List/index') },
    { path: '/manager/post-new-job', component: () => import('pages/Manager/Profile/index') },
    { path: '/manager/add-client', component: () => import('pages/Manager/Profile/index') },
    { path: '/notifications', component: () => import('pages/Notifications/index') },
    { path: '/zoom', component: () => import('pages/Zoom') },
    { path: '/manager/recruiters-jobs', component: () => import('pages/Manager/Recruiters/Jobs') },
    { path: '/clients-jobs', component: () => import('pages/Manager/Clients/Jobs') },
    {
      path: '/recruiters-clients',
      component: () => import('pages/Manager/Recruiters/ClientsList')
    },
    {
      path: '/skills/:id',
      component: () => import('pages/Manager/Skills/Edit/index')
    },
    {
      path: '/skills',
      component: () => import('pages/Manager/Skills/List/index')
    },

    /* @deprecated */
    { path: '/manager/jobs/view/:id', component: () => import('pages/Manager/Jobs/View/index') },
    {
      path: '/manager/jobs/:jobId/candidates/:candidateId',
      component: () => import('pages/Manager/Candidates/View/index')
    },
    {
      path: '/manager/jobs/:id/candidates',
      component: () => import('pages/Manager/Candidates/List/index')
    },
    { path: '/manager/jobs/:id', component: () => import('pages/Manager/Jobs/Edit/index') },
    { path: '/manager/jobs/clone/:id', component: () => import('pages/Manager/Jobs/Edit/index') },
    { path: '/manager/jobs', component: () => import('pages/Manager/Jobs/List/index') }
  ],

  recruiter: [
    { path: '/profile', component: () => import('pages/Recruiter/Profile/index') },
    { path: '/dashboard', component: () => import('pages/Recruiter/Dashboard/index') },
    {
      path: '/jobs/:jobsId/candidates/:id',
      component: () => import('pages/Recruiter/Candidates/View/index')
    },
    {
      path: '/jobs/view/:id',
      component: () => import('pages/Recruiter/Jobs/View/index')
    },
    { path: '/jobs', component: () => import('pages/Recruiter/Jobs/List/index') },
    {
      path: '/recruiter/managers/:id',
      component: () => import('pages/Recruiter/ProfileView/Manager')
    },
    {
      path: '/recruiter/recruiters/:id',
      component: () => import('pages/Recruiter/ProfileView/Recruiter')
    },
    {
      path: '/recruiter/candidates/add',
      component: () => import('pages/Recruiter/Candidates/Add/index')
    },
    {
      path: '/recruiter/candidates/add-from-resume/:id',
      component: () => import('pages/Recruiter/Candidates/AddFromResume/index')
    },
    {
      path: '/recruiter/candidates/:id/edit',
      component: () => import('pages/Recruiter/Candidates/Edit/index')
    },
    {
      path: '/recruiter/candidates/:id',
      component: () => import('pages/Recruiter/Candidates/View/index')
    },
    {
      path: '/recruiter/candidates',
      component: () => import('pages/Recruiter/Candidates/List/index')
    },
    {
      path: '/resumes/add',
      component: () => import('pages/Recruiter/Resumes/Add')
    },
    {
      path: '/resumes',
      component: () => import('pages/Recruiter/Resumes/List/index')
    },
    { path: '/messages', component: () => import('pages/Messages/index') },
    { path: '/notifications', component: () => import('pages/Notifications/index') },
    { path: '/zoom', component: () => import('pages/Zoom') },

    /* @deprecated */
    {
      path: '/recruiter/jobs/:jobsId/candidates/:id',
      component: () => import('pages/Recruiter/Candidates/View/index')
    },
    {
      path: '/recruiter/jobs/view/:id',
      component: () => import('pages/Recruiter/Jobs/View/index')
    },
    { path: '/recruiter/jobs', component: () => import('pages/Recruiter/Jobs/List/index') }
  ],

  candidate: [
    { path: '/dashboard', component: () => import('pages/Candidate/Dashboard/index') },
    { path: '/profile', component: () => import('pages/Candidate/Profile/index') },
    {
      path: '/candidate/managers/:id',
      component: () => import('pages/Candidate/ProfileView/Manager')
    },
    {
      path: '/candidate/candidates/:id',
      component: () => import('pages/Candidate/ProfileView/Candidate')
    },
    {
      path: '/candidate/recruiters/:id',
      component: () => import('pages/Candidate/ProfileView/Recruiter')
    },
    {
      path: '/jobs/view/:id',
      component: () => import('pages/Candidate/Jobs/View/index')
    },
    { path: '/jobs', component: () => import('pages/Candidate/Jobs/List/index') },
    { path: '/calendar', component: () => import('pages/Candidate/Calendar/index') },
    { path: '/messages', component: () => import('pages/Messages/index') },
    { path: '/notifications', component: () => import('pages/Notifications/index') },
    { path: '/zoom', component: () => import('pages/Zoom') },

    /* @deprecated */
    {
      path: '/candidate/jobs/view/:id',
      component: () => import('pages/Candidate/Jobs/View/index')
    },
    { path: '/candidate/jobs', component: () => import('pages/Candidate/Jobs/List/index') }
  ]
}

export function getAuthorizedPaths(): string[] {
  const all = Object.values(routes).reduce<string[]>((acc, arr) => {
    arr.forEach(r => acc.push(r.path))
    return acc
  }, [])

  return Array.from(new Set(all))
}

const AUTH_PATHS = getAuthorizedPaths()

export function isAuthorizedPath(pathname: string): boolean {
  return AUTH_PATHS.some(p => !!matchPath(pathname, { path: p, exact: false }))
}
